<template>
  <!--  -->
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form
        ref="form"
        inline
        :model="searchData"
        label-width=""
    >
      <el-form-item label="代理商名称">
        <el-input
            style="width: 200px"
            clearable
            v-model="searchData.company_name"
            size="mini"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="getList"
        >搜索
        </el-button>
        <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh"
            @click="reset"
        >重置
        </el-button>
      </el-form-item>
    </el-form>
    <el-button
        v-show="isShowBtn(AUTH_BTN.agent_list_add)"
        style="margin-bottom: 10px"
        icon="el-icon-plus"
        type="primary"
        size="mini"
        plain
        @click="goAdd"
    >新增
    </el-button>
    <!-- list -->
    <el-table :data="list">
      <el-table-column
          prop="company_name"
          label="代理商名称"
          min-width="120"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="linkman"
          label="联系人"
          min-width="120"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="mobile"
          label="联系手机号码"
          min-width="120"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="agent_login_account"
          label="代理商超管账号"
          min-width="120"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          prop="created_at"
          label="创建时间"
          min-width="160"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          label="操作"
          width="180"
          fixed="right"
      >
        <template slot-scope="{ row }">
          <el-link
              v-show="isShowBtn(AUTH_BTN.agent_list_edit)"
              style="margin-right: 10px"
              type="primary"
              :underline="false"
              @click="handleEdit(row)"
          >编辑
          </el-link>
          <el-link
              v-show="isShowBtn(AUTH_BTN.agent_list_del)"
              type="danger"
              :underline="false"
              @click="handleDel(row)"
          >删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        :total="total"
        :page.sync="searchData.page"
        :limit.sync="searchData.page_size"
        @pagination="getList"
    />
    <!-- 新增编辑 -->
    <el-dialog
        :title="formData.company_id ? '编辑' : '新增'"
        :visible.sync="show_update"
        width="width"
    >
      <el-form
          ref="form"
          :model="formData"
          label-width="140px"
      >
        <el-form-item
            label="代理商名称"
            prop="company_name"
            :rules="rules"
        >
          <el-input
              style="width: 80%"
              v-model="formData.company_name"
              clearable
              size="small"
              placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="联系人"
            prop="linkman"
            :rules="rules"
        >
          <el-input
              style="width: 80%"
              v-model="formData.linkman"
              clearable
              size="small"
              placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="手机号码"
            prop="mobile"
            :rules="rules"
        >
          <el-input
              style="width: 80%"
              v-model.trim="formData.mobile"
              clearable
              size="small"
              placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item
            label="代理商超管账号"
            prop="agent_login_account"
            :rules="rules"
        >
          <el-input
              style="width: 80%"
              v-model.trim="formData.agent_login_account"
              clearable
              size="small"
              placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item
            label="代理商超管密码"
            prop="agent_login_password"
            :rules="rules"
        >
          <el-input
              style="width: 80%"
              v-model.trim="formData.agent_login_password"
              clearable
              size="small"
              placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
            @click="show_update = false"
            size="small"
        >取 消
        </el-button>
        <el-button
            type="primary"
            @click="save"
            size="small"
        >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getListAPI, getDetailAPI, addAPI, editAPI, delAPI, changeStatusAPI, downloadFile} from './api'
import {authBtnMixin} from '@/mixins/authBtnMixin'

export default {
  name: 'Index',
  mixins: [authBtnMixin],
  data() {
    return {
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_update: false,
      show_qrcode: false,
      list: [],
      searchData: {
        page: 1,
        page_size: 10,
        company_name: '',
      },
      formData: {
        company_id: '',
        company_name: '',
        linkman: '',
        mobile: '',
        agent_login_account: '',
        agent_login_password: '',
      },
      total: 0,
      brand_list: [],
      username: ''
    }
  },
  computed: {
    is_super() {
      return this.$store.state.user.isAdmin
    }
  },
  watch: {},
  activated() {
  },
  mounted() {
    this.getList()
  },

  methods: {
    removeBg() {
      this.formData.user_address_form_bg = ''
    },
    // 状态
    changeStatus({share_qrcode_id, share_qrcode_status}) {
      let data = {share_qrcode_id, status: share_qrcode_status == 20 ? 20 : 10}
      console.log(data)
      changeStatusAPI(data).then(() => {
        this.$message.success('修改成功')
      })
    },
    downloadFile({name, share_qrcode}) {
      downloadFile(share_qrcode, this.username + '-' + name)
    },
    async getList() {
      const data = {...this.searchData}
      console.log(data, '@@@')
      if (!this.is_super) {
        data.agent_uid = this.$store.state.user.user.id
      }
      const res = await getListAPI(data)
      this.list = res.data
      this.total = res.total
    },
    // 新增
    goAdd() {
      this.formData = {
        company_id: '',
        company_name: '',
        linkman: '',
        mobile: '',
      }
      this.show_update = true
      this.$refs.form.resetFields()
    },
    // 编辑
    async handleEdit({company_id}) {
      const res = await getDetailAPI(company_id)
      this.formData = res
      this.show_update = true
      this.$refs.form.resetFields()
    },
    // 删除
    handleDel({company_id}) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            delAPI(company_id).then(() => {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.formData.company_id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功')
              this.show_update = false
              this.getList()
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('添加成功')
              this.show_update = false
              this.getList()
            })
          }
        }
      })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;

  .inviter {
    display: inline-flex;
    align-items: center;
    background: #f8f8f9;
    border-radius: 5px;
    padding: 0 20px;

    .inviter-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .inviter-name {
        font-weight: 600;
      }
    }
  }

  .balance-box {
    display: flex;
    // align-items: center;
    .balance-item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      background: #f5f5f5;
      border-radius: 5px;
      padding: 0 20px;
      margin-right: 20px;

      span {
        &:last-child {
          font-weight: 600;
        }
      }
    }
  }

  .code-list {
    background-color: #f5f5f5;
    border-radius: 5px;
    padding: 10px;

    .item {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 15px 0;
    }
  }

  .bg-box {
    line-height: 20px;

    .del-btn {
      line-height: 0px;
    }
  }
}
</style>
